import Cell from "../../../../model/form/cell";
import {CellItem} from "../../../../model/items/cellItem";
import {CheckboxItem} from "../../../../model/items/checkbox";
import {Questionary} from "../../../../model/questionary";
import m, {Vnode} from "mithril";

export default class CheckboxImageCell {

    private readonly checkbox!: CheckboxItem;
    private readonly questionary: Questionary;

    constructor(
        public readonly cell: Cell,
        private readonly setValue: ((cellItem: CellItem, value: any)=>void)|null = null
    ) {
        this.questionary = cell.grid.questionary;

        for (const item of cell.cellItems) {
            if (item instanceof CheckboxItem) {
                this.checkbox = item;
            }
        }

        if (!this.checkbox) {
            throw Error(`Expected checkbox in cell ${cell.id} missing.`);
        }
    }

    private imageFromCheckbox(selected: boolean): string|null {
        let file = null;
        const imageTag = this.checkbox.childrenTags.filter(t => t.tag === "image")[0];
        if (imageTag) {
            const imageAttributes = imageTag.attributes;
            file = (selected && imageAttributes.selected) ? imageAttributes.selected : imageAttributes.normal;
        }
        if (file !== null) {
            return this.questionary.getFileUrl(file);
        }
        return null;
    }



    public view(): Vnode|null {

        if (!this.cell.visible) {
            return null;
        }

        const enabled = this.cell.enabled;
        const checked = enabled && this.checkbox.getVariable();
        const description = this.checkbox.childrenTags[0]?.value;

        return m('.CheckboxImageCell'+(checked ? '.selected' : '')+(enabled ? '' : '.disabled'), {
            onclick: () => {
                const value = !this.checkbox.getVariable();
                if (this.setValue) {
                    this.setValue(this.checkbox, value && enabled);
                } else {
                    this.checkbox.setVariable(value && enabled);
                }
            },
        }, [
            m('img', {
                draggable: false,
                src: this.imageFromCheckbox(checked)
            }),
            description ? m('.description', {},  m.trust(this.questionary.renderText(description))) : null,
        ]);
    }

}